import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/category/portrait?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  const navLinks = [
    { label: '首页', to: '/' },
    { label: '作品分类', to: '/category/portrait' },
    { label: '摄影技巧', to: '/tutorials' },
    { label: '社区', to: '/forum' },
    { label: '关于', to: '/about' },
  ];

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
          <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-500">
            <i className="ri-camera-3-line text-background-50 text-lg md:text-xl"></i>
          </div>
          <span className="font-heading font-bold text-lg md:text-xl text-foreground-950">无节操摄影部</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden lg:flex items-center bg-background-100 border border-background-200 rounded-full px-4 py-2 w-64">
          <i className="ri-search-line text-foreground-500 text-sm mr-2"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索作品 / 作者 / 标签"
            className="bg-transparent outline-none text-sm text-foreground-800 placeholder-foreground-400 w-full"
          />
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full bg-background-100 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-800 text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 space-y-4">
          <form onSubmit={handleSearch} className="flex items-center bg-background-100 border border-background-200 rounded-full px-4 py-2.5">
            <i className="ri-search-line text-foreground-500 text-sm mr-2"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索作品 / 作者 / 标签"
              className="bg-transparent outline-none text-sm text-foreground-800 placeholder-foreground-400 w-full"
            />
          </form>
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className="py-2.5 px-2 text-sm font-label text-foreground-700 hover:bg-background-100 rounded-md cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="pt-2 border-t border-background-200">
            <p className="text-xs text-foreground-500 mb-2">热门分类</p>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 4).map((c) => (
                <Link
                  key={c.id}
                  to={`/category/${c.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-800 cursor-pointer whitespace-nowrap"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}